import { createIcon } from './create-icon';

export const PlusIcon = createIcon('PlusIcon', <path d="M12 5v14M5 12h14" />);
